"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.systemResultsCardClasses = void 0;
// istanbul ignore file: doesn't hold any logic
const SystemResultsCard_1 = __importDefault(require("./SystemResultsCard"));
var styles_1 = require("./styles");
Object.defineProperty(exports, "systemResultsCardClasses", { enumerable: true, get: function () { return styles_1.classes; } });
exports.default = SystemResultsCard_1.default;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvc3lzdGVtLXJlc3VsdHMtY2FyZC9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSwrQ0FBK0M7QUFDL0MsNEVBQW9EO0FBR3BELG1DQUErRDtBQUF0RCxrSEFBQSxPQUFPLE9BQTRCO0FBRTVDLGtCQUFlLDJCQUFpQixDQUFDIn0=